var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"logo",attrs:{"data-testid":"logo","href":"https://www.uva.nl/","target":"_blank"}},[_c('img',{staticClass:"logo__image",attrs:{"src":_vm.logo}})])}
var staticRenderFns = []

export { render, staticRenderFns }